import { Component, ReactElement } from 'react';
import { withSiteMeta } from '../../../../../../../shared/frontend/HOCS/withSiteMeta';
import { Media } from '../../../../../../../shared/frontend/components/presentational/media';
import { TKeystoneRunRankingsTableProps } from './types';
import { KeystoneRunRankingsTableSmall } from './KeystoneRunRankingsTableSmall';
import { KeystoneRunRankingsTableLarge } from './KeystoneRunRankingsTableLarge';

export const KeystoneRunRankingsTableBase = withSiteMeta(
  class extends Component<TKeystoneRunRankingsTableProps, {}> {
    public render(): ReactElement<TKeystoneRunRankingsTableProps> {
      if (this.props.component) {
        return <this.props.component {...this.props} />;
      } else {
        return (
          <>
            <Media at="sm">
              <KeystoneRunRankingsTableSmall {...this.props} />
            </Media>
            <Media greaterThan="sm">
              <KeystoneRunRankingsTableLarge {...this.props} />
            </Media>
          </>
        );
      }
    }
  }
);
